import zhCommon from './zh/common'

const messages = {
  zh: {
    common: zhCommon,
  },
}

export default messages